import React, { useState } from 'react';
import Icon from './Icon';
import {
    IsimpleOption,
    filterOptionsBySearch,
    toggleOption,
    toggleSelectAllVisible,
    areAllVisibleSelected
} from './multiSelectFilterUtil';

interface IMultiSelectFilterListProps {
    values: IsimpleOption[];
    options: IsimpleOption[];
    onChange: (selected: IsimpleOption[]) => void;
    searchPlaceholder?: string;
    emptyLabel?: string;
}

// The toolbar/modal are not translated (siblings hardcode "Room: All" etc.), so keep this inline.
const SELECT_ALL_LABEL = 'Select All';

/*
 * Presentational search + Select-All + checkbox list. Stateless w.r.t. the
 * selection (the parent owns `values`); only the search term is local.
 * Shared by the desktop MultiSelectFilterDropdown menu and the mobile filter modal.
 */
const MultiSelectFilterList: React.FC<IMultiSelectFilterListProps> = ({
    values,
    options,
    onChange,
    searchPlaceholder = 'Search...',
    emptyLabel = 'No options'
}) => {
    const [search, setSearch] = useState('');

    const visibleOptions = filterOptionsBySearch(options, search);
    const allVisibleSelected = areAllVisibleSelected(values, visibleOptions);

    return (
        <div className="multi-select-list">
            <div className="multi-select-search input-with-icon search">
                <Icon name="search" />
                <input
                    type="text"
                    value={search}
                    placeholder={searchPlaceholder}
                    onChange={e => setSearch(e.target.value)}
                    onKeyDown={e => e.stopPropagation()}
                />
            </div>

            {visibleOptions.length > 0 && (
                <label className="multi-select-option select-all">
                    <input
                        type="checkbox"
                        checked={allVisibleSelected}
                        onChange={() => onChange(toggleSelectAllVisible(values, visibleOptions))}
                    />
                    <span className="multi-select-option-label">{SELECT_ALL_LABEL}</span>
                </label>
            )}

            <div className="multi-select-option-list">
                {visibleOptions.length === 0 ? (
                    <div className="multi-select-empty">{emptyLabel}</div>
                ) : (
                    visibleOptions.map(option => {
                        const checked = values.some(item => item.value === option.value);
                        return (
                            <label key={option.value} className="multi-select-option">
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => onChange(toggleOption(values, option))}
                                />
                                <span className="multi-select-option-label">{option.label}</span>
                            </label>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default MultiSelectFilterList;
